module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/about/about.component.css
// module id = ./src/app/about/about.component.css
// module chunks = main